<template>
  <div>
    <TopHeader code="study" />

    <section class="container-fluid uc-bg">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="uc-crumb">
              <router-link to="/" class="item">首页</router-link>
              <router-link
                :to="{
                  name: 'LearningMapPath',
                  params: { id: $route.params.id },
                }"
                class="item"
                >学习</router-link
              >
              <router-link to="" class="item">学习地图</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-jobMap1">
      <div class="container">
        <div class="row">
          <div class="col-24 title">
            <div class="left">
              <h2>{{ model.name }}</h2>
              <div class="percent-box">
                <div class="percent">
                  <span class="per" :style="`width:${model.progress}%`"></span>
                </div>
                <i class="uc-blue">{{ model.progress }}%</i>
              </div>
            </div>
            <!-- <router-link class="uc-btn blue-plain" to="">进入考试</router-link> -->
          </div>
        </div>
        <div class="row list">
          <div class="col-24 col-sm-8 box">
            <div class="item">
              <h3>工作职责</h3>
              <div
                class="con"
                v-html="
                  model.job_requirements ? model.job_requirements : '暂无'
                "
              ></div>
            </div>
          </div>
          <div class="col-24 col-sm-8 box">
            <div class="item">
              <h3>任职资格</h3>
              <div
                class="con"
                v-html="model.description ? model.description : '暂无'"
              ></div>
            </div>
          </div>
          <div class="col-24 col-sm-8 box">
            <div class="item">
              <h3>能力要求</h3>
              <div
                class="con"
                v-html="
                  model.competence_requirements
                    ? model.competence_requirements
                    : '暂无'
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-jobMap2">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <section class="g-filterSearch">
              <div
                :class="tab == 'tab1' ? 'item on' : 'item'"
                @click="
                  tab = 'tab1';
                  loadData();
                "
              >
                学习中
              </div>
              <div
                :class="tab == 'tab2' ? 'item on' : 'item'"
                @click="
                  tab = 'tab2';
                  loadData();
                "
              >
                已完成
              </div>
              <div class="search">
                <input
                  type="text"
                  placeholder="请输入您想查询的课程"
                  class="uc-input"
                  v-model="queryCourse.keyword"
                />
                <input
                  type="submit"
                  value="搜索"
                  class="uc-btn blue"
                  @click="loadData"
                />
              </div>
            </section>
          </div>
        </div>

        <div v-show="tab == 'tab1'">
          <div class="row list">
            <div class="content-empty" v-show="list.total_count == 0">
              <div class="emptyimg-box"></div>
              <p>暂无相关内容</p>
            </div>
            <div v-for="(item, index) in list.items" :key="index" class="col-6">
              <div class="item">
                <router-link
                  :to="{
                    name: 'CourseDetails',
                    params: { id: item.id },
                    query: { from: 'learningMapStage', fromId: model.id },
                  }"
                  target="_blank"
                  class="con"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-kc.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <h3>{{ item.name }}</h3>
                    <div class="txt">
                      <span>{{ item.lecturer_name || '无讲师' }}</span
                      >|<span>{{ item.period }}分钟</span>
                    </div>
                    <div class="percent-box">
                      <div class="percent">
                        <span
                          class="per"
                          :style="`width:${item.browse_percent}%`"
                        ></span>
                      </div>
                      <i class="uc-blue">{{ item.browse_percent }}%</i>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div v-show="tab == 'tab2'">
          <div class="row list">
            <div class="content-empty" v-show="list.total_count == 0">
              <div class="emptyimg-box"></div>
              <p>暂无相关内容</p>
            </div>
            <div v-for="(item, index) in list.items" :key="index" class="col-6">
              <div class="item">
                <router-link
                  :to="{
                    name: 'CourseDetails',
                    params: { id: item.id },
                    query: { from: 'learningMapStage', fromId: model.id },
                  }"
                  target="_blank"
                  class="con"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/default-kc.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <h3>{{ item.name }}</h3>
                    <div class="txt">
                      <span>{{ item.lecturer_name || '无讲师' }}</span
                      >|<span>{{ item.period }}分钟</span>
                    </div>
                    <div class="percent-box">
                      <div class="percent">
                        <span
                          class="per"
                          :style="`width:${item.browse_percent}%`"
                        ></span>
                      </div>
                      <i class="uc-blue">{{ item.browse_percent }}%</i>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <el-pagination
          class="uc-prvNxt"
          background
          layout="prev, pager, next"
          hide-on-single-page
          :current-page="queryCourse.pageIndex"
          :page-size="queryCourse.pageSize"
          :total="list.total_count"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </section>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';

export default {
  name: 'LearningMapPathDetails',
  components: {
    TopHeader,
    BottomFooter,
  },
  data() {
    return {
      query: {
        mapId: this.$route.params.id,
        stageId: this.$route.query.stageId,
      },
      queryCourse: {
        stageId: this.$route.query.stageId,
        status: 0,
        pageIndex: 1,
        pageSize: 12,
        keyword: undefined,
      },
      tab: 'tab1',
      model: {},
      list: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getMapPathDetails();
      this.getMapPostCourses();
    },
    loadData() {
      this.queryCourse.pageIndex = 1;
      this.tab === 'tab1'
        ? (this.queryCourse.status = 0)
        : (this.queryCourse.status = 1);
      this.getMapPostCourses();
    },
    async getMapPathDetails() {
      console.log(this.query);
      const response = await this.$api.learningmap.getMapPathDetails(
        this.query
      );
      this.model = response.data.data;
    },
    async getMapPostCourses() {
      const response = await this.$api.learningmap.getMapPostCourses(
        this.queryCourse
      );
      this.list = response.data.data;
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryCourse.pageIndex = val;
      this.loadData();
    },
  },
};
</script>
